import React, { Component } from "react";
import {
  DKLabel,
  DKButton,
  DKInput,
  INPUT_TYPE,
  INPUT_VIEW_DIRECTION,
  DKCheckMark,
} from "deskera-ui-library";
import SegmentControl from "../common/SegmentControl";
import { COLUMN_CODE } from "../../managers/TableManger";
import ActivityManager from "./ActivityManager";
import Utility from "../../utility/Utility";
import DKInputDateTime from "../common/DKInputDateTime";

export default class ActivityPopup extends Component {
  state = {
    canValidate: false,
    formData: this.props.formFields,
    invalidEndDate: false,
  };

  componentDidMount() {
    this.getInit();
  }

  render() {
    return (
      <div className="transparent-background">
        <div
          className="border-radius-s bg-white shadow-m p-l popup-window"
          style={{ width: 450 }}
        >
          <div className="row justify-content-between ">
            <DKLabel
              text={this.props.isEdit ? "Edit Activity" : "Add Activity"}
              className="fw-m fs-l"
            />
            {this.getActionButtons()}
          </div>
          <div className="parent-width mt-xxl" style={{ maxWidth: 450 }}>
            <DKInput
              title="Name"
              type={INPUT_TYPE.TEXT}
              value={ActivityManager.getFieldData(
                this.state.formData,
                COLUMN_CODE.ACTIVITY.NAME
              )}
              direction={INPUT_VIEW_DIRECTION.VERTICAL}
              required
              canValidate={this.state.canValidate}
              onChange={(value) =>
                this.saveFormData(COLUMN_CODE.ACTIVITY.NAME, value)
              }
            />
            <DKLabel text="Activity Type" className=" mt-l mb-s" />
            <SegmentControl
              className="text-blue"
              data={this.props.dataList.activityType}
              onChange={(value) =>
                this.saveFormData(COLUMN_CODE.ACTIVITY.ACTIVTY_TYPE, value)
              }
              value={ActivityManager.getFieldData(
                this.state.formData,
                COLUMN_CODE.ACTIVITY.ACTIVTY_TYPE
              )}
            />

            <DKInputDateTime
              title={`Start Date*`}
              selectedDate={ActivityManager.getFieldData(
                this.state.formData,
                COLUMN_CODE.ACTIVITY.START_DATE
              )}
              onSave={(date) =>
                this.saveFormData(COLUMN_CODE.ACTIVITY.START_DATE, date)
              }
            />

            <DKInputDateTime
              title={`End Date*`}
              selectedDate={ActivityManager.getFieldData(
                this.state.formData,
                COLUMN_CODE.ACTIVITY.END_DATE
              )}
              onSave={(date) =>
                this.saveFormData(COLUMN_CODE.ACTIVITY.END_DATE, date)
              }
            />
            {this.state.invalidEndDate && (
              <div
                className="fs-r text-align-left text-red mt-s ml-xs"
                style={{ fontSize: "11px" }}
              >
                End date should be greater than start date
              </div>
            )}

            <DKInput
              title="Notes"
              type={INPUT_TYPE.TEXT}
              direction={INPUT_VIEW_DIRECTION.VERTICAL}
              required={false}
              className="mt-m"
              value={ActivityManager.getFieldData(
                this.state.formData,
                COLUMN_CODE.ACTIVITY.NOTES
              )}
              canValidate={this.state.canValidate}
              onChange={(value) =>
                this.saveFormData(COLUMN_CODE.ACTIVITY.NOTES, value)
              }
            />
            {/* <DKInput
              title="Assignee"
              type={INPUT_TYPE.MULTI_SELECT}
              direction={INPUT_VIEW_DIRECTION.VERTICAL}
              required={false}
              className="mt-m"
              option={[]}
              value={ActivityManager.getFieldData(this.state.formData, COLUMN_CODE.ACTIVITY.ASSIGNEE_IDS)}
              canValidate={this.state.canValidate}
              onChange={(value) => this.saveFormData(COLUMN_CODE.ACTIVITY.ASSIGNEE_IDS, value)}
            /> */}
            <DKInput
              title="Contacts"
              type={INPUT_TYPE.MULTI_SELECT}
              direction={INPUT_VIEW_DIRECTION.VERTICAL}
              required={false}
              className="mt-m"
              options={this.props.dataList.contacts}
              value={ActivityManager.getFieldData(
                this.state.formData,
                COLUMN_CODE.ACTIVITY.CONTACT_IDS
              )}
              canValidate={this.state.canValidate}
              onChange={(value) =>
                this.saveFormData(COLUMN_CODE.ACTIVITY.CONTACT_IDS, value)
              }
            />
            <DKInput
              title="Organizations"
              type={INPUT_TYPE.MULTI_SELECT}
              direction={INPUT_VIEW_DIRECTION.VERTICAL}
              required={false}
              className="mt-m"
              options={this.props.dataList.orgnizations}
              value={ActivityManager.getFieldData(
                this.state.formData,
                COLUMN_CODE.ACTIVITY.ORGANIZATION_IDS
              )}
              canValidate={this.state.canValidate}
              onChange={(value) =>
                this.saveFormData(COLUMN_CODE.ACTIVITY.ORGANIZATION_IDS, value)
              }
            />
            <DKInput
              title="Linked To"
              type={INPUT_TYPE.SELECT}
              direction={INPUT_VIEW_DIRECTION.VERTICAL}
              options={this.props.dataList.deals}
              required={false}
              className="mt-m"
              value={ActivityManager.getFieldData(
                this.state.formData,
                COLUMN_CODE.ACTIVITY.LINKED_TO
              )}
              canValidate={this.state.canValidate}
              onChange={(value) =>
                this.saveFormData(COLUMN_CODE.ACTIVITY.LINKED_TO, value)
              }
            />
            <DKCheckMark
              title="Mark As Done"
              className="mt-l mb-m"
              isSelected={ActivityManager.getFieldData(
                this.state.formData,
                COLUMN_CODE.ACTIVITY.STATUS
              )}
              onClick={(value) =>
                this.saveFormData(COLUMN_CODE.ACTIVITY.STATUS, value)
              }
            />
            {/* <DKCheckMark title="Send Reminder Email to Assignees." isSelected={ActivityManager.getFieldData(this.state.formData, COLUMN_CODE.ACTIVITY.SEND_INVITATION)} className="mt-s mb-s" onClick={(value) => this.saveFormData(COLUMN_CODE.ACTIVITY.SEND_INVITATION, value)} />
            <DKCheckMark title="Send Reminder Email to Contacts." isSelected={ActivityManager.getFieldData(this.state.formData, COLUMN_CODE.ACTIVITY.SEND_CONTACTS_INVITATION)} className="mt-s mb-s" onClick={(value) => this.saveFormData(COLUMN_CODE.ACTIVITY.SEND_CONTACTS_INVITATION, value)} /> */}
          </div>
        </div>
      </div>
    );
  }
  getActionButtons() {
    return (
      <div>
        <div className="row">
          <DKButton
            title="Cancel"
            className="bg-gray1 border-m"
            onClick={() => {
              this.props.onCancel();
            }}
          />
          <DKButton
            title="Save"
            className="bg-app text-white ml-r"
            onClick={() => {
              this.setState({
                canValidate: true,
              });
              if (this.props.onSubmit && this.isFormDataValid()) {
                this.props.onSubmit(this.state.formData);
              }
            }}
          />
        </div>
      </div>
    );
  }

  saveFormData = (key, value) => {
    let fieldData = this.state.formData.find((field) => field.key === key);
    if (
      key === COLUMN_CODE.ACTIVITY.STATUS ||
      key === COLUMN_CODE.ACTIVITY.SEND_INVITATION ||
      key === COLUMN_CODE.ACTIVITY.SEND_CONTACTS_INVITATION
    ) {
      fieldData.value = !fieldData.value;
    } else {
      fieldData.value = value;
    }
    this.setState({ formData: this.state.formData }, () => {
      this.validateActivityDates();
    });
  };

  isFormDataValid() {
    let valid = true;
    let startDate;
    let endDate;
    this.state.formData.forEach((field) => {
      if (field.required !== false) {
        if (
          field.value === null ||
          field.value === undefined ||
          field.value === ""
        ) {
          valid = false;
        } else if (
          field.type === INPUT_TYPE.EMAIL &&
          !Utility.isValidEmail(field.value)
        ) {
          valid = false;
        } else if (field.type === INPUT_TYPE.NUMBER && isNaN(field.value)) {
          valid = false;
        } else if (
          (field.type === INPUT_TYPE.SELECT ||
            field.type === INPUT_TYPE.MULTI_SELECT) &&
          field.value.length === 0
        ) {
          valid = false;
        } else if (field.type === INPUT_TYPE.DATE) {
          if (field.key === "start_date") {
            startDate = field.value;
          }
          if (field.key === "end_date") {
            endDate = field.value;
          }
          if (startDate > endDate) {
            valid = false;
            this.setState({ invalidEndDate: true });
          } else {
            this.setState({ invalidEndDate: false });
          }
        }
      }
    });
    return valid;
  }

  getInit = () => {
    let startDate = ActivityManager.getFieldData(
      this.state.formData,
      COLUMN_CODE.ACTIVITY.START_DATE
    );
    if (startDate === "") {
      this.saveFormData(
        COLUMN_CODE.ACTIVITY.START_DATE,
        new Date().toISOString()
      );
    }
    let endDate = ActivityManager.getFieldData(
      this.state.formData,
      COLUMN_CODE.ACTIVITY.END_DATE
    );
    if (endDate === "") {
      this.saveFormData(
        COLUMN_CODE.ACTIVITY.END_DATE,
        new Date().toISOString()
      );
    }
  };
  validateActivityDates = () => {
    let { formData } = this.state;
    const startDate = formData.find(
      (field) => field.key === COLUMN_CODE.ACTIVITY.START_DATE
    ).value;
    const endDate = formData.find(
      (field) => field.key === COLUMN_CODE.ACTIVITY.END_DATE
    ).value;
    const isStartDateValid =
      new Date(startDate).getTime() >= new Date().getTime();
    const isEndDateValid =
      new Date(endDate).getTime() >= new Date().getTime() &&
      new Date(endDate).getTime() > new Date(startDate).getTime();
    if (isStartDateValid && isEndDateValid) {
      this.setState({ invalidEndDate: false });
    }
  };
}
